<template>
    <div class="works-detail">
        <div class="works-container">
            <div class="detail-top">
                <div class="works-title">{{detail.title}}</div>
                <div class="create-time">上传时间:{{detail.create_time}}</div>
            </div>
            <div class="detail-content" v-viewer>
                <div class="works-desc" v-if="detail.status === 5">
                    <div class="desc-label">修改意见:</div>
                    <div class="desc-content">{{detail.edit_reason}}</div>
                </div>
                <div class="works-desc">
                    <div class="desc-label">设计说明:</div>
                    <div class="desc-content">{{detail.content}}</div>
                </div>
                <div class="img-list">
                    <img v-for="(item,index) in detail.image_list" class="works-img" :key="index" :src="item" alt="" />
                </div>
            </div>
        </div>
        <div class="bottom-bar">
            <div style="width:40%">
                <span>温馨提示：</span>精美设计更需实物加持，定制大赛专属样衣，专业版型、精致工艺，完美还原你的创意细节，提升评委印象分，助力作品脱颖而出
            </div>
            <div v-if="detail.status == 5" class="submit-apply" @click="show_upload=true">编辑</div>
            <div class="submit-apply" @click="onApply">{{ apply_sample?'我的样衣信息':'已有样衣，申请开店上架' }} </div>
            <div class="design-button" @click="onDesign">立即定制样衣,让优秀设计被看见</div>
        </div>
        <SubmitResult v-if="show_result" @close="onCloseSubmitResult" @confirm="onSubmitResultConfirm" @apply="onApply"></SubmitResult>
        <SubmitWorks v-if="show_upload" :detail="detail" :matchUUID="form.match_uuid" :formData="form" @close="onCloseSubmitWorks" @confirm="onSubmitWorksConfirm"></SubmitWorks>
    </div>
</template>
<script>
import { SaveDraft } from '@/api/index';
import {
    CheckApplyMatchSample,
    GetMatchPostDetail
} from "@/api/social";
import SubmitResult from './components/SubmitResult';
import SubmitWorks from "./components/SubmitWorks.vue";
export default{
    components:{
        SubmitWorks,
        SubmitResult
    },
    name:"WorksDetail",
    data(){
        return{
            detail:{},
            apply_sample:null,
            show_result:false,
            show_upload:false,
            form:{}
        }
    },
    mounted(){
        this.getDetail();
    },
    methods:{
        onCloseSubmitResult(){
            this.show_result = false;
            this.getDetail();
        },
        async onSubmitResultConfirm(){
            if(!this.form.image_list || !this.form.image_list.length){
                this.$layer.msg('请完善作品图片');
                return;
            }
            const {data} = await SaveDraft({image_list:this.form.image_list,scene:'bc'});
            if(!data.uuid){
                this.$layer.msg('操作失败,请稍后重试~');
                return;
            }
            this.$layer.msg('操作成功,即将跳转样衣定制~');
            setTimeout(()=>{
                this.show_result = false;
                // this.$refs['up_form'].resetFields();
                this.form.image_list = [];
                this.$router.push({name:"WorkBenchDesign",query:{uuid:data.uuid,from:'draft'}});
            },500)
        },
        async onSubmitWorksConfirm(data){
            console.log('data',data);
            this.form.image_list = data.image_list;
            this.show_upload = false;
            await this.getDetail();
            this.show_result = true;
        },
        onCloseSubmitWorks(){
            this.show_upload = false;
        },
        async getDetail() {
            console.log('query-==>',this.$route.query);
            const { uuid } = this.$route.query;
            console.log('uuid===>',uuid);
            // return;
            if (!uuid) {
                this.$layer.msg('缺少作品ID~');
                this.$router.back();
                return;
            }
            try {
                const { code, data } = await GetMatchPostDetail({ uuid });
                if (code !== 0 || !data) {
                    this.$layer.msg('查无作品~');
                    this.$router.back();
                    return;
                }
                this.detail = data;
                this.form = {
                    title:data.title,
                    content:data.content,
                    image_list:data.image_list,
                    uuid:data.uuid,
                    match_uuid:data.match_uuid,
                    status:data.status,
                    custom_field:data.custom_field
                }
                console.log('form-->',this.form);
                this.getCheckInfo();
            } catch (e) {
                console.log("err", e);
                this.$layer.msg('获取作品详情失败~');
                this.$router.back();
            }
        },
        async getCheckInfo() {
            try {
                const { code, data } = await CheckApplyMatchSample({
                    match_uuid:this.detail.match_uuid
                });
                if(data){
                    this.apply_sample = data;
                }
            } catch (e) {
                console.log("err", e);
            }
        },
        onApply(){
            if(this.show_result) this.show_result = false;
            this.$router.push({name:"ContestSampleApply",query:{uuid:this.detail.match_uuid}});
        },
        async onDesign(){
            const {data} = await SaveDraft({image_list:this.detail.image_list,scene:'bc'});
            if(!data.uuid){
                this.$layer.msg('操作失败,请重试或联系客服~');
                return;
            }
            this.$layer.msg('操作成功,即将跳转定制~');
            setTimeout(()=>{
                this.$router.push({name:"WorkBenchDesign",query:{uuid:data.uuid,from:'draft'}});
            },500);
        },
    }
}
</script>
<style lang="scss" scoped>
.works-detail{
    width:100%;
    height:auto;
    min-height:calc(100vh - 160px);
    background:#f8f9fb;
    display:flex;
    justify-content:center;
    padding-top:14px;
    .works-container{
        flex:0 0 1200px;
        background:#fff;
        padding:24px 32px;
        margin-bottom:150px;
        .detail-top{
            display:flex;
            flex-direction:column;
            align-items:center;
            row-gap:8px;
            width:100%;
            margin-bottom:24px;
            padding-bottom:20px;
            border-bottom:1px solid #e3e3e3;
            .works-title{
                color:#000;
                font-size:24px;
            }
            .create-time{
                color:#666;
                font-size:14px;
            }
        }
        .detail-content{
            width:100%;
            display:flex;
            flex-direction:column;
            align-items:center;
            row-gap:16px;
            .works-desc{
                display:flex;
                flex-direction:column;
                row-gap:10px;
                margin-bottom:8px;
                width:100%;
                .desc-label{
                    color:#333;
                    font-size:16px;
                    font-weight:bold;
                }
                .desc-content{
                    color:#333;
                    font-size:14px;
                }
            }
            .img-list{
                display:flex;
                flex-direction:column;
                width:600px;
                row-gap:20px;
            }
            .works-img{
                width:100%;
                height:auto;
                object-fit:cover;
            }
        }
    }
    .bottom-bar{
        width:100%;
        height:80px;
        background:#fff;
        box-shadow:0 -4px 4px 0 #8b8b8b1a;
        display:flex;
        align-items:center;
        justify-content:center;
        column-gap:52px;
        color:#333;
        font-size:14px;
        // padding:16px 0; 
        position:fixed;
        bottom:45px;
        left:0;
        user-select:none;
        span{
            color:#ff5967;
        }
        .design-button{
            background:#ff5967;
            border-radius:24px;
            color:#fff;
            font-size:16px;
            font-weight:bold;
            display:flex;
            align-items:center;
            justify-content:center;
            padding:12px 20px;
            cursor:pointer;
            flex-shrink:0;
        }
        .submit-apply{
            width:325px;
            height:48px;
            background:#ffffff;
            color:#FF5967;
            display:flex;
            align-items:center;
            justify-content:center;
            cursor:pointer;
            border-radius:30px;
            flex-shrink:0;
            border:1px solid #FF5967;
        }
    }
}
</style>